<template>
  <b-container fluid>
    <div v-if="show">
      <Teacher :units_for_teacher="units_for_teacher"/>
    </div>
    <b-card v-else class="text-center">
      <b-card-text v-if="load">Loading</b-card-text>
      <b-card-text v-else-if="loadError">
        <p>Something went wrong loading this page.</p>
        <p>Please try again. If it still doesn't work, contact us at hello@truewayasl.com</p></b-card-text>
      <b-card-text v-else>
        <p>It looks like the page expired. Please close the page and try again.</p>
        <p>If it still doesn't work, contact us at hello@truewayasl.com</p></b-card-text>
    </b-card>
    <div class="text-right">
      <span class="small text-muted">token: {{ this.token }}</span>
    </div>
  </b-container>
</template>

<script>
import {checkAccess} from "@/utils/lti-api"
import {initBeacon, reportErrorToBeacon} from "@/utils/beacon"
import Teacher from '@/components/Teacher'

export default {
  components: {
    Teacher
  },
  data() {
    return {
      units_for_teacher: ['1'],
      show: false,
      load: true,
      loadError: false
    }
  },
  computed: {
    state() {
      return this.$route.query.state || null
    },
    token() {
      return this.$route.query.token || null
    },
  },
  methods: {
    async checkAccess() {
      try {
        let response = await checkAccess('teacher', this.token, this.state)
        console.log("response", response)
        // Redirect to WTS if Teacher Resources is hidden for this course
        if (response.shows_teacher_resources === false) {
          this.$router.replace({ path: '/lti/wts', query: { token: this.token, state: this.state }})
          return
        }
        this.units_for_teacher = response.units_for_teacher
        this.show = true
      } catch (error) {
        // 401 = the launch expired (normal — keep the "page expired" copy);
        // anything else is a real failure. Either way arm Beacon so "contact us"
        // arrives with the underlying error attached.
        this.loadError = !(error.response && error.response.status === 401)
        initBeacon()
        reportErrorToBeacon(error, 'Teacher Resources Load Error',
          { 'Flow': 'Teacher Resources (LTI 1.3)', 'Token': this.token })
      }
      this.load = false
    }
  },
  mounted() {
    this.checkAccess()
  }
}
</script>
